"use client";
import { Sport } from "common";
import React from "react";
import Table, { ColumnDef } from "@/components/primitives/table";
import TeamDisplay from "@/components/team/display";
import { LeagueStatLeaderData } from "./data";

export default function TeamLeagueStatLeaderTable({
  sport,
  category,
  data,
}: {
  sport: Sport;
  category: string;
  data: LeagueStatLeaderData[];
}) {
  const columns: ColumnDef<LeagueStatLeaderData>[] = React.useMemo(
    () => [
      {
        header: "Rank",
        accessorKey: "rank",
        enableSorting: false,
        width: "50px",
      },
      {
        header: "Team",
        maxWidth: "240px",
        cell: (info) => {
          const row = info.row.original;
          return (
            <TeamDisplay
              sport={sport}
              size="xs"
              variant="location-name"
              team={row.team}
            />
          );
        },
      },
      {
        header: (info) => {
          return (
            <div className="flex flex-row w-full pr-1 items-center justify-end">
              {category}
            </div>
          );
        },
        accessorKey: "value",
        cell: (info) => {
          return (
            <div className="flex flex-row w-full pr-1 items-center justify-end">
              {`${info.getValue()}`}
            </div>
          );
        },
        enableSorting: false,
      },
    ],
    []
  );

  return <Table type="banded" columns={columns} data={data} />;
}
